import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircleIcon, ChevronDownIcon } from 'lucide-react';
const faqs = [{
  question: 'What does GreenHS offer?',
  answer: 'GreenHS provides daily free football predictions and a premium VIP plan that delivers accurate 2–5 odds daily for serious bettors.'
}, {
  question: 'How do I join the VIP group?',
  answer: "Simply click the Join VIP button on the site. You'll be redirected to the dedicated VIP subscription page."
}, {
  question: 'What do I gain from the VIP plan?',
  answer: 'You get a carefully analyzed daily 2–5 odds ticket delivered directly to our VIP channel — zero noise, maximum accuracy.'
}, {
  question: 'When do free predictions get updated?',
  answer: 'Free predictions are updated daily, usually in the early hours of the day.'
}, {
  question: 'Are the predictions guaranteed?',
  answer: 'No prediction is ever 100% guaranteed, but we maintain a 90% success rate through disciplined analysis, smart filters, and strict selection methods.'
}, {
  question: 'How can I reach support?',
  answer: 'You can contact support through our official Telegram support'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section id="faq" className="w-full py-20 px-4 bg-dark-card" data-id="element-9">
      <div className="container mx-auto max-w-4xl" data-id="element-10">
        {/* Section Header */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-11">
          <div className="inline-flex items-center gap-2 bg-neon-purple/10 px-4 py-2 rounded-full mb-4" data-id="element-12">
            <HelpCircleIcon className="w-5 h-5 text-neon-purple" data-id="element-13" />
            <span className="text-neon-purple font-semibold text-sm" data-id="element-14">
              HELP CENTER
            </span>
          </div>

          <h2 className="text-2xl md:text-5xl font-black mb-4" data-id="element-15">
            <span className="bg-gradient-to-r from-neon-purple to-neon-cyan bg-clip-text text-transparent" data-id="element-16">
              Frequently Asked Questions
            </span>
          </h2>

          <p className="text-gray-400 text-base md:text-lg" data-id="element-17">
            Everything you need to know about GreenHS
          </p>
        </motion.div>

        {/* FAQ Accordion */}
        <div className="space-y-4" data-id="element-18">
          {faqs.map((faq, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} data-id="element-19">
              <div className="bg-dark-base/50 backdrop-blur-sm rounded-2xl border border-gray-800 hover:border-neon-cyan/30 transition-all overflow-hidden" data-id="element-20">
                <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-5 md:p-6 text-left group" data-id="element-21">
                  <span className="text-base md:text-lg font-bold text-white group-hover:text-neon-cyan transition-colors pr-4" data-id="element-22">
                    {faq.question}
                  </span>
                  <motion.div animate={{
                rotate: openIndex === index ? 180 : 0
              }} transition={{
                duration: 0.3
              }} className="flex-shrink-0" data-id="element-23">
                    <ChevronDownIcon className="w-5 h-5 md:w-6 md:h-6 text-neon-cyan" data-id="element-24" />
                  </motion.div>
                </button>

                <AnimatePresence data-id="element-25">
                  {openIndex === index && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3
              }} className="overflow-hidden" data-id="element-26">
                      <div className="px-5 md:px-6 pb-5 md:pb-6 text-sm md:text-base text-gray-400 leading-relaxed" data-id="element-27">
                        {faq.answer}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </div>
            </motion.div>)}
        </div>

        {/* Contact CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-12 text-center" data-id="element-28">
          <p className="text-gray-400 mb-4 text-sm md:text-base" data-id="element-29">
            Got any questions?
          </p>
          <a href="https://t.me/m/P_Y7-ueGMzk0" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-6 py-3 bg-neon-cyan border border-dark-base/30 rounded-xl font-semibold text-sm md:text-base text-white hover:bg-neon-cyan/10 hover:border-neon-cyan/50 transition-all" data-id="element-30">
            Contact Support on Telegram
          </a>
        </motion.div>
      </div>
    </section>;
}